module.exports = __webpack_public_path__ + "static/media/Install_PrintPlugin.b8f152c7.zip";